import { Box } from "@mui/system";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { crudDe } from "../../../services/acesso";
import api from "../../../services/api";
import { FiTruck } from "react-icons/fi";
import { Tab, Tabs, Typography } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { showButtonList } from "../../../components/button-list";
import { confirm } from "../../../components/confirm";
import Listagem, { ConfiguracaoFiltros } from "../../../components/listagem";
import { useAppSelector } from "../../../store/hooks";
import ModalForm from "../../../components/modal-form";
import { MdAttachMoney, MdBuild } from "react-icons/md";
import { useCallback, useEffect, useState, useMemo } from "react";
import { formatarParaReais, parseDecimal } from "../../../services/utilitarios";
import { useFiliais } from "../../../hooks/useFiliais";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import { TipoFormulario, TipoVeiculo } from "../../../services/constantes";
import { ApiError, Banco, Campo, Opcao, Peca, Servico, ServicoVeiculo, StatusOrdemDeServico, OrdemDeServico } from "../../../services/tipos";
import { ehPlanoGratuito, estaEmPeriodoDeTeste, obterIdTenent, usuarioTemPermissao } from "../../../services/seguranca";
import { FaCalendarCheck, FaCarSide, FaCheckCircle, FaEdit, FaExclamationTriangle, FaExchangeAlt, FaFilePdf, FaMoneyBillAlt, FaMotorcycle, FaBan, FaTag, FaTimesCircle, FaTools, FaTrash, FaWarehouse } from "react-icons/fa";
import { ReciboManutencao } from "../../../components/recibo-manutencao";

interface VeiculoInfo {
    placa: string;
    marca: string;
    modelo: string;
    ano: string;
}

function ServicoVeiculoListagem() {
    const { empresaTemFiliais, filiaisOptions, getCampoFilial, getAcaoEmLoteFilial, labelComFilial } = useFiliais();
    const navigate = useHistory();
    const location = useLocation();
    const [pecas, setPecas] = useState<Peca[]>([]);
    const [totalPecas, setTotalPecas] = useState(0);
    const token = useAppSelector(state => state.token);
    const [carregando, setCarregando] = useState(true);
    const [consultasPendentes, setConsultasPendentes] = useState(0);
    const [totalServicos, setTotalServicos] = useState(0);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [servicos, setServicos] = useState<Servico[]>([]);
    const [totalManutencao, setTotalManutencao] = useState(0);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [realizarConsulta, setRealizarConsulta] = useState(true);
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState<boolean>(false);
    const [veiculosOptions, setVeiculosOptions] = useState<Opcao[]>([]);
    const [exibirFormModalPeca, setExibirFormModalPeca] = useState(false);
    const [realizarConsultaPeca, setRealizarConsultaPeca] = useState(true);
    const [servicosVeiculos, setServicosVeiculos] = useState<ServicoVeiculo[]>([]);
    const [servicoVeiculoPeca, setServicoVeiculoPeca] = useState<Peca[]>([]);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [exibirFormModalServico, setExibirFormModalServico] = useState(false);
    const [realizarConsultaServico, setRealizarConsultaServico] = useState(true);
    const [servicoVeiculoServico, setServicoVeiculoServico] = useState<Servico[]>([]);
    const [forcarAtualizacaoGrid, setForcarAtualizacaoGrid] = useState<boolean>(false);
    const [prestadorDeServicoOptions, setPrestadorDeServicoOptions] = useState<Opcao[]>([]);
    const [entidadeParaAtualizarNoModal, setEntidadeParaAtualizarNoModal] = useState<any>({});
    const [servicoVeiculoPecasSelecionados, setServicoVeiculoPecasSelecionados] = useState<any[]>([]);
    const [forcarAtualizacaoDeEntidadeNoModal, setForcarAtualizacaoDeEntidadeNoModal] = useState(false);
    const [servicoVeiculoServicosSelecionados, setServicoVeiculoServicosSelecionados] = useState<any[]>([]);
    const [servicoVeiculoSelecionado, setServicoVeiculoSelecionado] = useState<ServicoVeiculo>({} as ServicoVeiculo);
    const [garantiaRemovida, setGarantiaRemovida] = useState<boolean>(false);
    const [reciboRemovido, setReciboRemovido] = useState<boolean>(false);
    const [imagemRemovida, setImagemRemovida] = useState<boolean>(false);
    const [usaPecaDoEstoque, setUsaPecaDoEstoque] = useState<boolean>(false);
    const [ehOrdemServico, setEhOrdemServico] = useState<boolean>(false);
    const [triggerGerarPDFOS, setTriggerGerarPDFOS] = useState<number>(0);
    const [gerandoOS, setGerandoOS] = useState(false);
    const [mostrarAvancadoManutencao, setMostrarAvancadoManutencao] = useState(false);
    const [bancosManutencaoOpcoes, setBancosManutencaoOpcoes] = useState<{ label: string; valor: string }[]>([]);
    const [integradoRastreador, setIntegradoRastreador] = useState<boolean>(false);

    const [abaManutencao, setAbaManutencao] = useState(0);
    const [ordensDeServico, setOrdensDeServico] = useState<OrdemDeServico[]>([]);
    const [realizarConsultaOS, setRealizarConsultaOS] = useState(true);
    const [carregandoOS, setCarregandoOS] = useState(false);
    const [modoConversao, setModoConversao] = useState(false);
    const [osParaConverter, setOsParaConverter] = useState<OrdemDeServico | null>(null);
    const [osEmEdicao, setOsEmEdicao] = useState<OrdemDeServico | null>(null);

    const [veiculosRaw, setVeiculosRaw] = useState<any[]>([]);
    const [filialNoForm, setFilialNoForm] = useState<string | null>(null);
    const [dataInicio, setDataInicio] = useState<Date | null>(null);
    const [dataFim, setDataFim] = useState<Date | null>(null);
    const [idVeiculoEscolhido, setIdVeiculoEscolhido] = useState<string>("");
    const [pecasEscolhidas, setPecasEscolhidas] = useState<string[]>([]);
    const [servicosEscolhidos, setServicosEscolhidos] = useState<string[]>([]);
    const [tipoPeriodo, setTipoPeriodo] = useState<"realizacao" | "pagamento">("realizacao");

    const [rowCount, setRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25,
    });

    const iniciarConsulta = () => {
        setConsultasPendentes(prev => prev + 1);
        setCarregando(true);
    };

    const finalizarConsulta = () => {
        setConsultasPendentes(prev => {
            const novoValor = prev - 1;
            if (novoValor === 0) {
                setCarregando(false);
            }
            return novoValor;
        });
    };

    const formatarDataHoraExportacao = (valor: any) => {
        if (!valor) return '';
        const data = new Date(valor);
        if (isNaN(data.getTime())) return '';
        const hora = data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', hour12: false });
        return hora === '00:00' ? data.toLocaleDateString('pt-BR') : `${data.toLocaleDateString('pt-BR')} ${hora}`;
    };

    const colunas = useMemo(() => [
        {
            field: 'veiculo',
            headerName: 'Veículo',
            flex: 1.5,
            renderCell: (params: any) => {
                const veiculo = params.row.veiculo;

                const getVehicleIcon = () => {
                    switch (Number(veiculo?.tipoVeiculo)) {
                        case 1: return <FaCarSide size={16} />;
                        case 2: return <FaMotorcycle size={16} />;
                        case 3: return <FiTruck size={16} />;
                        default: return <FaCarSide size={16} />;
                    }
                };

                if (!veiculo) return '';
                return (
                    <Box display="flex" alignItems="center" gap={1.25}>
                        <Box color="#4A5568" display="flex">{getVehicleIcon()}</Box>
                        <Box display="flex" flexDirection="column">
                            <Typography variant="body2" fontWeight={600} lineHeight={1.3}>{veiculo.placa}</Typography>
                            <Typography variant="caption" color="#718096" lineHeight={1.3}>
                                {[veiculo.marca, veiculo.modelo].filter(Boolean).join(' ')}{veiculo.ano ? ` • ${veiculo.ano}` : ''}
                            </Typography>
                        </Box>
                    </Box>
                );
            },
            valueGetter: (params: any) =>
                [params.row.veiculo?.placa, params.row.veiculo?.marca, params.row.veiculo?.modelo].filter(Boolean).join(' - ')
        },
        {
            field: 'valor', headerName: 'Valor', flex: 0.5, renderCell(params: any) {
                return formatarParaReais(Number(params.value))
            }
        },
        {
            field: 'dataRealizado',
            headerName: 'Data Realizado',
            flex: 1,
            valueGetter: (params: any) => new Date(params.value),
            renderCell: (params: any) => {
                const date = new Date(params.value);
                if (isNaN(date.getTime())) return '';
                const hora = date.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", hour12: false });
                return (
                    <Box display="flex" flexDirection="column">
                        <Typography variant="body2" lineHeight={1.3}>{date.toLocaleDateString("pt-BR")}</Typography>
                        {hora !== "00:00" && <Typography variant="caption" color="#718096" lineHeight={1.3}>{hora}</Typography>}
                    </Box>
                );
            }
        },
        { field: 'hodometro', headerName: 'Hodômetro', flex: 0.5 },
        { field: 'descricao', headerName: 'Descrição', flex: 2 },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ], [empresaTemFiliais, filiaisOptions]);

    // Exportação com colunas explícitas (DL-193): sem isso o grid exportava toda propriedade da linha,
    // inclusive as URLs assinadas de garantia e recibo, e o texto das células renderizadas saía colado.
    const exportOptions = useMemo(() => [
        { field: 'veiculo', headerName: 'Veículo', valueGetter: ({ row }: { row: any }) => [row.veiculo?.placa, row.veiculo?.marca, row.veiculo?.modelo, row.veiculo?.ano].filter(Boolean).join(' ') },
        { field: 'dataRealizado', headerName: 'Data Realizado', valueGetter: ({ row }: { row: any }) => formatarDataHoraExportacao(row.dataRealizado) },
        { field: 'hodometro', headerName: 'Hodômetro', valueGetter: ({ row }: { row: any }) => row.hodometro ?? '' },
        { field: 'descricao', headerName: 'Descrição', valueGetter: ({ row }: { row: any }) => row.descricao ?? '' },
        { field: 'prestadorServico', headerName: 'Prestador', valueGetter: ({ row }: { row: any }) => row.prestadorServico?.nome ?? '' },
        { field: 'valor', headerName: 'Valor', valueGetter: ({ row }: { row: any }) => formatarParaReais(Number(row.valor ?? 0)) },
        { field: 'parcelas', headerName: 'Parcelas', valueGetter: ({ row }: { row: any }) => row.parcelas ?? '' },
        { field: 'dataPagamento', headerName: 'Data Pagamento', valueGetter: ({ row }: { row: any }) => formatarDataHoraExportacao(row.dataPagamento) },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', valueGetter: ({ row }: { row: any }) => filiaisOptions.find((x: any) => x.valor === row.idFilial)?.label ?? '' }] : []),
    ], [empresaTemFiliais, filiaisOptions]);

    const camposServico: Campo[] = useMemo(() => [
        { label: 'Nome', nome: 'nome', required: true, tipo: 'text', largura: 6, coluna: 1, linha: 1, visible: true, tudoMaiusculo: true },
        { label: 'Valor', nome: 'valor', required: true, tipo: 'money', largura: 6, coluna: 2, linha: 1, visible: true, ajudinha: { texto: "Este campo refere-se ao valor do serviço, sendo sugerido como valor base nas movimentações de Manutenções.", autoCloseTime: 3 } },
        { label: 'Periodicidade em KM', nome: 'periodoEmKm', required: false, tipo: 'number', largura: 12, coluna: 1, linha: 2, visible: true, ajudinha: { texto: "Este campo se refere à vida útil do serviço em quilômetros. \nEle será utilizado posteriormente pela nossa inteligência artificial para identificar a necessidade de realizar a próxima manutenção.", autoCloseTime: 3 } },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 3, visible: false, tudoMaiusculo: true }
    ], []);

    const camposPecas: Campo[] = useMemo(() => [
        { label: 'Tipo do veículo', nome: 'tipoVeiculo', required: true, tipo: 'select', largura: 6, coluna: 1, linha: 1, visible: true, opcoes: [{ label: 'Carro', valor: TipoVeiculo.tpCarro }, { label: 'Moto', valor: TipoVeiculo.tpMoto }, { label: 'Ambos', valor: TipoVeiculo.tpAmbos }], ajudinha: { texto: 'Este campo indica o tipo de veículo ao qual a peça está associada. Ele será útil para que, durante a movimentação de serviços, sejam exibidas apenas as peças compatíveis com o tipo de veículo em questão.', autoCloseTime: 3 } },
        { label: 'Nome', nome: 'nome', required: true, tipo: 'text', largura: 6, coluna: 2, linha: 1, visible: true, tudoMaiusculo: true },
        { label: 'Marca', nome: 'marca', required: true, tipo: 'text', largura: 12, coluna: 1, linha: 3, visible: true, tudoMaiusculo: true },
        { label: 'Modelo/Número', nome: 'modelo', required: true, tipo: 'text', largura: 12, coluna: 1, linha: 4, visible: true, tudoMaiusculo: true },
        { label: 'Vida útil (km)', nome: 'vidaUtilEmKm', required: false, tipo: 'number', largura: 12, coluna: 1, linha: 5, visible: true },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 6, visible: false, tudoMaiusculo: true }
    ], []);

    const pages = useMemo(() => {
        const informacoesCampos = ehOrdemServico
            ? ["alertaSobrePrazoMinimo", "dataRealizado", "idPrestadorServico", "descricao", "_toggleAvancadoManutencao", "_labelBancoInfoManutencao", "_alertaBancosDivergentesManutencao", "idBanco"]
            : ["alertaSobrePrazoMinimo", "valor", "valorMaoDeObra", "valorPecas", "parcelas", "dataRealizado", "dataPagamento", "idPrestadorServico", "descricao", "_toggleAvancadoManutencao", "_labelBancoInfoManutencao", "_alertaBancosDivergentesManutencao", "idBanco"];

        const paginasBase = [];

        if ((modo == TipoFormulario.tpCadastro) && !modoConversao && !ehOrdemServico) {
            paginasBase.push({
                titulo: "Tipo",
                campos: ["tipoManutencao"]
            });
        }

        paginasBase.push(
            {
                titulo: "Veículo",
                campos: ["idVeiculo", "hodometro"]
            },
            {
                titulo: "Peças",
                campos: ["peca"]
            },
            {
                titulo: "Serviços",
                campos: ["servico"]
            },
            {
                titulo: "Informações",
                campos: informacoesCampos
            }
        );

        if (!ehOrdemServico) {
            paginasBase.push({
                titulo: "Arquivos",
                campos: ["garantia", "recibo", "imagem"]
            });
        }

        return paginasBase;
    }, [ehOrdemServico, modo, modoConversao]);

    const handleServicosChange = useCallback((data: any) => {
        setServicoVeiculoServico(data);
        setServicoVeiculoServicosSelecionados(data);

        let somaServicos = 0.0;
        data.forEach((s: any) => {
            const valor = parseDecimal(s.valor) || 0;
            somaServicos += valor;
        });

        setTotalServicos(somaServicos);

        const valorTotal = somaServicos + totalPecas;

        setEntidadeParaAtualizarNoModal({
            valorMaoDeObra: somaServicos,
            valor: valorTotal
        });
        setForcarAtualizacaoDeEntidadeNoModal(true);
    }, [totalPecas]);

    const handlePecasChange = useCallback((data: any) => {
        setServicoVeiculoPeca(data);
        setServicoVeiculoPecasSelecionados(data);
        setUsaPecaDoEstoque(false);

        let somaValorPeca = 0.0;
        let usaEstoque = false;

        data.forEach((p: any) => {
            if (p.provenienteDoEstoque === 'sim') {
                usaEstoque = true;
            }
            const valor = p.provenienteDoEstoque === 'sim' ? 0 : parseDecimal(p.valor) || 0;
            const qtd = parseDecimal(p.qtdEstoque) || 0;
            somaValorPeca += valor * qtd;
        });

        setUsaPecaDoEstoque(usaEstoque);
        setTotalPecas(somaValorPeca);

        const valorTotal = somaValorPeca + totalServicos;

        setEntidadeParaAtualizarNoModal({
            valorPecas: somaValorPeca,
            valor: valorTotal
        });
        setForcarAtualizacaoDeEntidadeNoModal(true);
    }, [totalServicos]);

    const campoFilial = getCampoFilial({ linha: 0, coluna: 1, largura: 6, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) });

    // Filtra veículos pelo filial selecionado no formulário
    const veiculosOptionsFiltrados = filialNoForm
        ? veiculosRaw.filter((v: any) => !v.idFilial || v.idFilial === filialNoForm).map((v: any) => ({
            valor: v.id,
            label: labelComFilial(`${v.placa}: ${v.marca} ${v.modelo} ${v.ano}`, v.idFilial),
        }))
        : veiculosOptions;

    const campos: Campo[] = useMemo(() => [
        ...(campoFilial ? [campoFilial] : []),
        {
            label: 'O que deseja fazer?',
            nome: 'tipoManutencao',
            required: true,
            tipo: 'select',
            largura: 12,
            coluna: 1,
            linha: 0,
            visible: modo === TipoFormulario.tpCadastro,
            opcoes: [
                { label: 'Manutenção', valor: 'normal' },
                { label: 'Ordem de Serviço', valor: 'os' }
            ],
            onCampoDigitar(e: any) {
                if (e) {
                    setEhOrdemServico(e === 'os');
                }
            },
        },
        { label: 'Informações do Veículo', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true },
        {
            label: 'Veículo', nome: 'idVeiculo', required: true, tipo: 'select', largura: 8, coluna: 1, linha: 2, visible: true, apenasLeitura: modoConversao, opcoes: veiculosOptionsFiltrados, onCampoSair(e: any) {
                if (e) {
                    const ultimoHodometro = buscarUltimoHodometroLocal(e);
                    if (ultimoHodometro) {
                        setEntidadeParaAtualizarNoModal({ hodometro: ultimoHodometro })
                        setForcarAtualizacaoDeEntidadeNoModal(true);
                    }

                    const label = veiculosOptions.find(v => v.valor === e)?.label || '';
                    const placa = label.split(':')[0].trim();
                    if (placa) {
                        api.get(`/AzulMonitor/Odometro/${obterIdTenent(token)}/${placa.replace('-', '').toUpperCase()}`)
                            .then(res => {
                                if (res.data?.encontrado) {
                                    setEntidadeParaAtualizarNoModal({ hodometro: Math.round(res.data.odometroKm) });
                                    setForcarAtualizacaoDeEntidadeNoModal(true);
                                }
                            })
                            .catch(() => {});
                    }
                }
            }
        },
        { label: 'Hodômetro atual', nome: 'hodometro', required: true, tipo: 'number', largura: 4, coluna: 2, linha: 2, visible: true, apenasLeitura: modoConversao },
        { label: 'Informações da Manutenção', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 3, visible: true },
        {
            label: '', alertMessage: 'O valor das peças provenientes do seu estoque não é contabilizado no custo da manutenção, pois já foi registrado no momento da entrada', nome: 'alertaSobrePrazoMinimo', required: false, tipo: 'aviso', largura: 12, coluna: 1, linha: 1,
            visible: ((modo === TipoFormulario.tpCadastro || modo === TipoFormulario.tpEdicao) && usaPecaDoEstoque), alertType: 'info', alertDismissible: true, alertTitle: "Atenção:"
        },
        { label: 'Total em Mão de Obra', nome: 'valorMaoDeObra', required: false, tipo: 'money', largura: 4, coluna: 1, linha: 5, visible: !ehOrdemServico, ajudinha: { texto: "Este campo corresponde ao valor gasto em Mão de obra/serviços", autoCloseTime: 3 }, apenasLeitura: true },
        { label: 'Total em Peças', nome: 'valorPecas', required: false, tipo: 'money', largura: 4, coluna: 2, linha: 5, visible: !ehOrdemServico, ajudinha: { texto: "Este campo corresponde ao valor gasto em Peças", autoCloseTime: 3 }, apenasLeitura: true },
        { label: 'Valor Total', nome: 'valor', required: false, tipo: 'money', largura: 4, coluna: 3, linha: 5, visible: !ehOrdemServico, ajudinha: { texto: "Este campo corresponde ao valor total do serviço, incluindo mão de obra da oficina, peças, taxas e outros custos envolvidos.", autoCloseTime: 3 } },
        {
            coluna: 1, label: 'Como você pagou?', largura: 4, nome: 'parcelas', tipo: 'select', linha: 6, required: !ehOrdemServico, visible: !ehOrdemServico, opcoes: [
                { label: "À vista", valor: 1 },
                { label: "Em 2x", valor: 2 },
                { label: "Em 3x", valor: 3 },
                { label: "Em 4x", valor: 4 },
                { label: "Em 5x", valor: 5 },
                { label: "Em 6x", valor: 6 },
                { label: "Em 7x", valor: 7 },
                { label: "Em 8x", valor: 8 },
                { label: "Em 9x", valor: 9 },
                { label: "Em 10x", valor: 10 },
                { label: "Em 11x", valor: 11 },
                { label: "Em 12x", valor: 12 },
            ],
        },
        { label: ehOrdemServico ? 'Previsão de início' : 'Data em que foi feita', nome: 'dataRealizado', required: true, tipo: 'datetime-local', largura: 4, coluna: 2, linha: 6, visible: true, ajudinha: { texto: ehOrdemServico ? "Este campo refere-se à data prevista para a execução do serviço." : "Este campo refere-se à data em que o veículo foi entregue ou o serviço foi concluído. A partir dessa data, será possível planejar as próximas manutenções com base nas peças e serviços registrados.", autoCloseTime: 3 } },
        { label: 'Data do Pagamento', nome: 'dataPagamento', required: !ehOrdemServico, tipo: 'datetime-local', largura: 4, coluna: 2, linha: 6, visible: !ehOrdemServico, ajudinha: { texto: "Este campo indica a data em que o pagamento da manutenção foi realizado; em caso de parcelamento, as parcelas serão contabilizadas a partir dessa data, portanto, se for no cartão de crédito, informe a data da primeira parcela e não a data em que o cartão foi passado.", autoCloseTime: 3 } },
        { label: 'Prestador de serviço', nome: 'idPrestadorServico', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 6, visible: true, apenasLeitura: modoConversao, opcoes: prestadorDeServicoOptions, ajudinha: { texto: "Este campo indica quem foi o responsável pela execução do serviço. Se não desejar utilizar um responsável pré-cadastrado, selecione a opção AVULSO.", autoCloseTime: 3 } },
        {
            label: 'Serviços realizados',
            nome: 'servico',
            required: false,
            tipo: 'selectgrid',
            largura: 12,
            coluna: 1,
            linha: 7,
            visible: true,
            selectGridProps: {
                dataSource: servicos,
                onDataSourceChange: handleServicosChange,
                optionLabelField: 'nome',
                onAcaoExtra: () => setExibirFormModalServico(true),
                columns: [
                    {
                        label: 'Valor',
                        value: 'valor', editable: true, type: "decimal", modalField: { linha: 2, label: "Valor", tipo: "money", coluna: 1, largura: 6, nome: "valor", required: false, apenasLeitura: false },
                    },
                    { label: 'Descrição', value: 'nome', editable: true, modalField: { linha: 1, label: "Descrição", tipo: "text", coluna: 1, largura: 6, nome: "nome", required: false, apenasLeitura: true } },
                ],
                initialGridData: servicoVeiculoServicosSelecionados,
                height: '300px',
                modo: modo,
                tituloBotaoExtra: "Novo",
                iconeBotaoExtra: MdBuild,
                forceUpdate: forcarAtualizacaoGrid,
                setData: servicoVeiculoServicosSelecionados,
                modalTitle: "Inserir Serviço/Mão de Obra",
                modalSaveButtonText: "Inserir"
            }
        },
        {
            label: 'Peças utilizadas',
            nome: 'peca',
            required: false,
            tipo: 'selectgrid',
            largura: 12,
            coluna: 2,
            linha: 6,
            visible: true,
            selectGridProps: {
                dataSource: pecas,
                onDataSourceChange: handlePecasChange,
                optionLabelField: 'marca;modelo;nome',
                onAcaoExtra: () => setExibirFormModalPeca(true),
                columns: [
                    { label: 'Marca', value: 'marca', editable: true, modalField: { linha: 2, label: "Marca", tipo: "text", coluna: 1, largura: 4, nome: "marca", required: false, apenasLeitura: true, }, onlyModal: true },
                    { label: 'Modelo', value: 'modelo', editable: true, modalField: { linha: 2, label: "Modelo", tipo: "text", coluna: 2, largura: 4, nome: "modelo", required: false, apenasLeitura: true }, onlyModal: true },
                    { label: 'Nome', value: 'nome', editable: true, modalField: { linha: 2, label: "Nome", tipo: "text", coluna: 3, largura: 4, nome: "nome", required: false, apenasLeitura: true }, onlyModal: true },

                    {
                        label: 'Peça',
                        value: 'nome',
                        renderCell: (value, row) => (
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>


                                <div style={{ flex: 1 }}>
                                    <div style={{
                                        fontWeight: 600,
                                        color: '#1F2937',
                                    }}>
                                        {value || 'Nome não informado'}
                                    </div>

                                    <div style={{
                                        display: 'flex',
                                        gap: '12px',
                                        fontSize: '13px',
                                        color: '#6B7280',
                                        flexWrap: 'wrap'
                                    }}>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            {row.marca || 'Sem marca'} • {row.modelo || 'Sem modelo'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                    },
                    {
                        label: 'Un.',
                        value: 'qtdEstoque',
                        editable: true,
                        type: "decimal",
                        modalField: {
                            linha: 1,
                            label: "Quantidade usada",
                            tipo: "number",
                            coluna: 1,
                            largura: 4,
                            nome: "qtdEstoque",
                            required: true
                        },
                        renderCell: (value) => (
                            <div style={{
                                fontWeight: 600,
                                color: '#1E40AF',
                                textAlign: 'center'
                            }}>
                                {value || '0'}
                            </div>
                        )
                    },
                    {
                        label: 'Valor',
                        value: 'valor',
                        editable: true,
                        type: "decimal",
                        modalField: {
                            linha: 1,
                            label: "Preço da Unidade",
                            tipo: "money",
                            coluna: 2,
                            largura: 5,
                            nome: "valor",
                            required: false
                        },
                        renderCell: (value) => (
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                color: '#065F46',
                                fontWeight: 600
                            }}>
                                <MdAttachMoney size={16} />
                                <span>{formatarParaReais(value || 0)}</span>
                            </div>
                        )
                    },
                    {
                        label: 'Estoque',
                        value: 'provenienteDoEstoque',
                        type: "text",
                        editable: true,
                        modalField: {
                            linha: 1,
                            label: "Do Estoque?",
                            tipo: "text",
                            coluna: 3,
                            largura: 3,
                            nome: "provenienteDoEstoque",
                            required: false,
                            apenasLeitura: true
                        },
                        renderCell: (value) => {
                            const isFromStock = value === 'sim';
                            return (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    color: isFromStock ? '#10B981' : '#EF4444'
                                }}>
                                    {isFromStock ? (
                                        <FaCheckCircle size={18} title="Disponível no estoque" />
                                    ) : (
                                        <FaTimesCircle size={18} title="Peça será usada do seu Estoque" />
                                    )}
                                </div>
                            );
                        }
                    }
                ],
                initialGridData: servicoVeiculoPecasSelecionados,
                height: '350px',
                modo: modo,
                tituloBotaoExtra: "Novo",
                iconeBotaoExtra: FaTools,
                useGridOptions: true,
                gridColumns: [
                    {
                        label: 'Produto',
                        field: 'nome',
                        renderCell: (value, row) => (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '8px 0' }}>
                                <div style={{ fontWeight: 600, color: '#1F2937' }}>{value || 'Nome não informado'}</div>
                                <div style={{ fontSize: '13px', color: '#6B7280' }}>
                                    Marca: <strong>{row.marca || 'Sem marca'}</strong><br />
                                    Modelo: <strong>{row.modelo || 'Sem modelo'}</strong>
                                </div>
                            </div>
                        )
                    },
                    {
                        label: 'Estoque',
                        field: 'qtdEstoque',
                        defaultValue: "0",
                        renderCell: (value, row) => {
                            const qtd = parseFloat(value) || 0;
                            const isLowStock = qtd > 0 && qtd < 5;
                            const isOutOfStock = qtd === 0;
                            const isFromStock = row.provenienteDoEstoque === 'sim';

                            if (!isFromStock) return null;

                            return (
                                <div
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '4px 10px',
                                        borderRadius: '6px',
                                        background: isOutOfStock
                                            ? '#FEE2E2'
                                            : isLowStock
                                                ? '#FEF3C7'
                                                : '#D1FAE5',
                                        color: isOutOfStock
                                            ? '#B91C1C'
                                            : isLowStock
                                                ? '#92400E'
                                                : '#065F46',
                                        fontWeight: 600,
                                        fontSize: '14px'
                                    }}
                                >
                                    {isOutOfStock ? (
                                        <FaTimesCircle size={14} />
                                    ) : isLowStock ? (
                                        <FaExclamationTriangle size={14} />
                                    ) : (
                                        <FaCheckCircle size={14} />
                                    )}
                                    <span>
                                        {isOutOfStock
                                            ? 'Sem Estoque'
                                            : isLowStock
                                                ? `Estoque Baixo (${qtd})`
                                                : `Estoque: ${qtd}`}
                                    </span>
                                </div>
                            );
                        }
                    },
                    {
                        label: 'Preço',
                        field: 'valor',
                        defaultValue: "0",
                        renderCell: (value) => {
                            const valor = parseFloat(value) || 0;
                            const isFree = valor === 0;

                            if (isFree) {
                                return null;
                            }
                            return (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '6px 10px',
                                    borderRadius: '6px',
                                    background: isFree ? '#EFF6FF' : '#ECFDF5',
                                    color: isFree ? '#1E40AF' : '#047857',
                                    fontWeight: 600,
                                    fontFamily: 'monospace',
                                    fontSize: '14px'
                                }}>

                                    <>
                                        <span>{formatarParaReais(valor)}</span>
                                    </>

                                </div>
                            );
                        }
                    },
                    {
                        label: 'Origem',
                        field: 'provenienteDoEstoque',
                        defaultValue: "Não",
                        renderCell: (value) => {
                            const isFromStock = value === 'sim';

                            return (
                                <span style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    background: isFromStock ? '#F3E8FF' : '#1F467E',
                                    color: isFromStock ? '#6B21A8' : '#FFF',
                                    fontWeight: 500,
                                    fontSize: '13px'
                                }}>
                                    <div style={{
                                        width: '8px',
                                        height: '8px',
                                        borderRadius: '50%',
                                        background: isFromStock ? '#8B5CF6' : '#FFF'
                                    }} />
                                    {isFromStock ? 'Tem no seu estoque' : 'Clique para incluir'}
                                </span>
                            );
                        }
                    }
                ],

                forceUpdate: forcarAtualizacaoGrid,
                setData: servicoVeiculoPecasSelecionados,
                modalTitle: "Inserir peça",
                modalSaveButtonText: "Inserir",
                diffField: "provenienteDoEstoque"
            }
        },
        {
            label: 'Observação',
            nome: 'descricao',
            required: false,
            tipo: 'memo',
            largura: 12,
            coluna: 1,
            linha: 8,
            visible: true,
        },
        {
            label: 'Garantia',
            nome: 'garantia',
            required: false,
            tipo: 'file',
            largura: 4,
            coluna: 1,
            linha: 9,
            visible: true,
        },
        {
            label: 'Recibo',
            nome: 'recibo',
            required: false,
            tipo: 'file',
            largura: 4,
            coluna: 2,
            linha: 9,
            visible: true,
        },
        {
            label: 'Imagem',
            nome: 'imagem',
            required: false,
            tipo: 'image',
            largura: 4,
            coluna: 3,
            linha: 9,
            visible: true,
        },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 9, visible: false, tudoMaiusculo: true },
        {
            label: '', nome: '_toggleAvancadoManutencao', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 90,
            component: () => (
                <button
                    type="button"
                    onClick={() => setMostrarAvancadoManutencao(!mostrarAvancadoManutencao)}
                    style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
                >
                    {mostrarAvancadoManutencao ? 'Ocultar opções avançadas' : 'Mostrar opções avançadas'}
                </button>
            ),
        },
        {
            label: 'Atenção', nome: '_labelBancoInfoManutencao', tipo: 'label', required: false,
            largura: 12, coluna: 1, linha: 91, visible: () => mostrarAvancadoManutencao,
            subLabel: 'A informação do banco será aplicada aos lançamentos financeiros gerados a partir desta manutenção.',
        },
        {
            label: 'Atenção', nome: '_alertaBancosDivergentesManutencao', tipo: 'label', required: false,
            largura: 12, coluna: 1, linha: 91, visible: () => mostrarAvancadoManutencao && !!(servicoVeiculoSelecionado as any)?.bancosDivergentes,
            subLabel: '⚠️ Lançamentos vinculados possuem bancos distintos. Alterar aqui sobrescreverá todos.',
        },
        {
            label: 'Banco para Pagamento/Recebimento', nome: 'idBanco', tipo: 'select', required: false,
            largura: 12, coluna: 1, linha: 92, visible: () => mostrarAvancadoManutencao,
            selectBoxIsCleareable: true,
            opcoes: bancosManutencaoOpcoes,
        },
    ], [veiculosOptions, veiculosOptionsFiltrados, prestadorDeServicoOptions, servicos, pecas, modo, servicoVeiculoServicosSelecionados, servicoVeiculoPecasSelecionados, ehOrdemServico, handleServicosChange, handlePecasChange, usaPecaDoEstoque, mostrarAvancadoManutencao, bancosManutencaoOpcoes, servicoVeiculoSelecionado, modoConversao]);

    useEffect(() => {
        if (!exibirFormModal) {
            if (servicoVeiculoSelecionado && Object.keys(servicoVeiculoSelecionado).length > 0) {
                setTimeout(() => {
                    setServicoVeiculoSelecionado({} as ServicoVeiculo);
                }, 1000);
            }
        }
    }, [exibirFormModal]);

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModal) {
            setForcarAtualizacaoDeEntidadeNoModal(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModal]);

    const onSave = useCallback(async (entidade: any) => {
        if (isSubmiting) return;

        setIsSubmiting(true);

        if (!usuarioTemPermissao(token, 'servicoveiculo_novo') && !usuarioTemPermissao(token, 'servicoveiculo_editar')) {
            setIsSubmiting(false);
            return;
        }

        if (modoConversao && osParaConverter) {
            try {
                const servicosDoServicoVeiculo = (servicoVeiculoServico.length > 0
                    ? servicoVeiculoServico
                    : servicoVeiculoServicosSelecionados).map((s: any) => ({
                        idServico: s.id,
                        valor: parseDecimal(s.valor) || 0
                    }));

                const pecasDoServicoVeiculo = (servicoVeiculoPeca.length > 0
                    ? servicoVeiculoPeca
                    : servicoVeiculoPecasSelecionados).map((p: any) => ({
                        idPeca: p.id,
                        provenienteDoEstoque: p.provenienteDoEstoque,
                        quantidadeUsada: String(p.qtdEstoque),
                        valor: parseDecimal(p.valor) || 0
                    }));

                const dadosManutencao = {
                    dataCadastro: new Date().toISOString(),
                    valor: parseDecimal(entidade.valor) || 0,
                    valorMaoDeObra: parseDecimal(entidade.valorMaoDeObra) || 0,
                    valorPecas: parseDecimal(entidade.valorPecas) || 0,
                    idVeiculo: entidade.idVeiculo,
                    idEmpresa: obterIdTenent(token),
                    hodometro: parseDecimal(entidade.hodometro) || 0,
                    descricao: entidade.descricao || '',
                    dataRealizado: entidade.dataRealizado,
                    servicoVeiculoPecas: pecasDoServicoVeiculo,
                    servicoVeiculoServicos: servicosDoServicoVeiculo,
                    idPrestadorServico: entidade.idPrestadorServico,
                    parcelas: entidade.parcelas || 1,
                    dataPagamento: entidade.dataPagamento,
                    ...(entidade.idBanco ? { idBanco: entidade.idBanco } : {}),
                    ...(osParaConverter.idFilial ? { idFilial: osParaConverter.idFilial } : {})
                };

                await api.post(`/ordemDeServico/${osParaConverter.id}/converter`, dadosManutencao);

                setTimeout(() => {
                    toast.success('Ordem de Serviço convertida em manutenção com sucesso');
                    setExibirFormModal(false);
                    setModoConversao(false);
                    setOsParaConverter(null);
                    setRealizarConsulta(true);
                    setRealizarConsultaOS(true);
                    setIsSubmiting(false);
                }, 250);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
                setIsSubmiting(false);
            }
            return;
        }

        if (ehOrdemServico) {
            try {
                const servicosOS = (servicoVeiculoServico.length > 0
                    ? servicoVeiculoServico
                    : servicoVeiculoServicosSelecionados).map((s: any) => ({
                        idServico: s.id,
                        valor: parseDecimal(s.valor) || 0
                    }));

                const pecasOS = (servicoVeiculoPeca.length > 0
                    ? servicoVeiculoPeca
                    : servicoVeiculoPecasSelecionados).map((p: any) => ({
                        idPeca: p.id,
                        provenienteDoEstoque: p.provenienteDoEstoque,
                        quantidadeUsada: parseDecimal(p.qtdEstoque) || 0,
                        valor: parseDecimal(p.valor) || 0
                    }));

                if (servicosOS.length === 0 && pecasOS.length === 0) {
                    toast.error('Adicione pelo menos um serviço ou peça para gerar a Ordem de Serviço');
                    setIsSubmiting(false);
                    return;
                }

                if (!entidade.idVeiculo) {
                    toast.error('Selecione um veículo para gerar a Ordem de Serviço');
                    setIsSubmiting(false);
                    return;
                }

                if (!entidade.idPrestadorServico) {
                    toast.error('Selecione um prestador de serviço para gerar a Ordem de Serviço');
                    setIsSubmiting(false);
                    return;
                }

                const editandoOS = modo === TipoFormulario.tpEdicao && !!osEmEdicao;

                const ordemDeServico: any = {
                    idVeiculo: entidade.idVeiculo,
                    idEmpresa: obterIdTenent(token),
                    hodometro: parseDecimal(entidade.hodometro) || 0,
                    dataCadastro: new Date().toISOString(),
                    dataRealizado: entidade.dataRealizado,
                    descricao: entidade.descricao || '',
                    status: StatusOrdemDeServico.Aberta,
                    idPrestadorServico: entidade.idPrestadorServico,
                    ordemDeServicoServicos: servicosOS,
                    ordemDeServicoPecas: pecasOS,
                    ...(entidade.idFilial ? { idFilial: entidade.idFilial } : {}),
                    ...(editandoOS ? { id: osEmEdicao!.id } : {})
                };

                if (editandoOS) {
                    await api.put(`/ordemDeServico/${osEmEdicao!.id}`, ordemDeServico);
                } else {
                    await api.post('/ordemDeServico', ordemDeServico);
                }

                let veiculoInfo: VeiculoInfo | undefined;
                try {
                    const responseVeiculo = await api.get(`Veiculo/${entidade.idVeiculo}`);
                    const veiculo = responseVeiculo.data;
                    veiculoInfo = {
                        placa: veiculo.placa || 'N/A',
                        marca: veiculo.marca || 'N/A',
                        modelo: veiculo.modelo || 'N/A',
                        ano: veiculo.ano ? String(veiculo.ano) : 'N/A'
                    };
                } catch (error) {
                    const veiculoSelecionado = veiculosOptions.find(v => v.valor === entidade.idVeiculo);
                    veiculoInfo = {
                        placa: veiculoSelecionado?.label?.split(':')[0]?.trim() || 'N/A',
                        marca: 'N/A',
                        modelo: 'N/A',
                        ano: 'N/A'
                    };
                }

                const prestadorSelecionado = prestadorDeServicoOptions.find(p => p.valor === entidade.idPrestadorServico);

                const manutencaoOS: any = {
                    id: undefined,
                    hodometro: parseDecimal(entidade.hodometro) || 0,
                    descricao: entidade.descricao || '',
                    dataRealizado: entidade.dataRealizado,
                    veiculo: veiculoInfo,
                    prestadorServico: prestadorSelecionado ? { nome: prestadorSelecionado.label } : undefined,
                    servicoVeiculoServicos: (servicoVeiculoServico.length > 0 ? servicoVeiculoServico : servicoVeiculoServicosSelecionados).map((s: any) => ({ servico: { nome: s.nome }, nome: s.nome })),
                    servicoVeiculoPecas: (servicoVeiculoPeca.length > 0 ? servicoVeiculoPeca : servicoVeiculoPecasSelecionados).map((p: any) => ({ peca: { nome: p.nome, marca: p.marca, modelo: p.modelo }, nome: p.nome, marca: p.marca, modelo: p.modelo, quantidadeUsada: parseDecimal(p.qtdEstoque) || 0 })),
                    imagem: undefined,
                };

                setExibirFormModal(false);

                setTimeout(() => {
                    setServicoVeiculoSelecionado(manutencaoOS);
                    setTriggerGerarPDFOS(prev => prev + 1);

                    setEhOrdemServico(false);
                    setOsEmEdicao(null);
                    setServicoVeiculoServicosSelecionados([]);
                    setServicoVeiculoPecasSelecionados([]);
                    setServicoVeiculoServico([]);
                    setServicoVeiculoPeca([]);
                    setTotalServicos(0);
                    setTotalPecas(0);
                    setRealizarConsultaOS(true);
                }, 100);

                toast.success(editandoOS ? 'Ordem de Serviço atualizada com sucesso' : 'Ordem de Serviço salva com sucesso');
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            } finally {
                setIsSubmiting(false);
            }
            return;
        }

        try {
            const dadosASalvar = new FormData();

            const servicosDoServicoVeiculo = (servicoVeiculoServico.length > 0
                ? servicoVeiculoServico
                : servicoVeiculoServicosSelecionados).map((s: any) => ({
                    idServico: s.id,
                    valor: parseDecimal(s.valor) || 0
                }));

                const pecasDoServicoVeiculo = (servicoVeiculoPeca.length > 0
                    ? servicoVeiculoPeca
                    : servicoVeiculoPecasSelecionados).map((p: any) => ({
                        idPeca: p.id,
                        provenienteDoEstoque: p.provenienteDoEstoque,
                        quantidadeUsada: String(p.qtdEstoque), 
                        valor: parseDecimal(p.valor) || 0
                    }));

            const servicoVeiculoASalvar = {
                dataCadastro: new Date().toDateString(),
                valor: parseDecimal(entidade.valor) || 0,
                valorMaoDeObra: parseDecimal(entidade.valorMaoDeObra) || 0,
                valorPecas: parseDecimal(entidade.valorPecas) || 0,
                idVeiculo: entidade.idVeiculo,
                idEmpresa: obterIdTenent(token),
                hodometro: parseDecimal(entidade.hodometro) || 0,
                descricao: entidade.descricao || '',
                dataRealizado: entidade.dataRealizado,
                servicoVeiculoPecas: pecasDoServicoVeiculo,
                servicoVeiculoServicos: servicosDoServicoVeiculo,
                idPrestadorServico: entidade.idPrestadorServico,
                parcelas: entidade.parcelas || 1,
                dataPagamento: entidade.dataPagamento,
                ...(modo === TipoFormulario.tpEdicao && { id: entidade.id }),
                ...(entidade.idBanco ? { idBanco: entidade.idBanco } : {}),
                ...(entidade.idFilial ? { idFilial: entidade.idFilial } : {})
            };

            for (const key in servicoVeiculoASalvar) {
                const value = (servicoVeiculoASalvar as any)[key];

                if (Array.isArray(value)) {
                    value.forEach((item, index) => {
                        for (const prop in item) {
                            dadosASalvar.append(`${key}[${index}].${prop}`, item[prop]);
                        }
                    });
                } else {
                    dadosASalvar.append(key, value);
                }
            }

            if (entidade.garantia) dadosASalvar.append("garantia", entidade.garantia);
            if (entidade.recibo) dadosASalvar.append("recibo", entidade.recibo);
            if (entidade.imagem) dadosASalvar.append("imagem", entidade.imagem);

            const garantiaRemoved = garantiaRemovida && !entidade.garantia;
            dadosASalvar.append("removerGarantia", String(garantiaRemoved));

            const reciboRemoved = reciboRemovido && !entidade.recibo;
            dadosASalvar.append("removerRecibo", String(reciboRemoved));

            const imagemRemoved = imagemRemovida && !entidade.imagem;
            dadosASalvar.append("removerImagem", String(imagemRemoved));

            await (modo === TipoFormulario.tpCadastro ? api.post : api.put)(
                '/servicoVeiculo/',
                dadosASalvar,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            setTimeout(async () => {
                setRealizarConsulta(true);
                setExibirFormModal(false);
                toast.success('Manutenção salva com sucesso');
                setIsSubmiting(false);

                if (modo === TipoFormulario.tpCadastro && integradoRastreador) {
                    const pecasUsadas = (servicoVeiculoPeca.length > 0
                        ? servicoVeiculoPeca
                        : servicoVeiculoPecasSelecionados);

                    if (pecasUsadas.length > 0) {
                        await showButtonList({
                            title: "Plano de Manutenção",
                            message: "Deseja criar um plano de manutenção preventiva para as peças utilizadas?",
                            buttons: [
                                {
                                    icon: <FaCalendarCheck />,
                                    title: "Sim, criar plano",
                                    description: "Acompanhe quando realizar a próxima manutenção",
                                    onClick: () => {
                                        const pecasParam = pecasUsadas.map((p: any) => ({
                                            id: p.id,
                                            nome: p.nome,
                                            vidaUtilEmKm: p.vidaUtilEmKm || 5000
                                        }));
                                        const params = new URLSearchParams();
                                        params.set('criar', 'true');
                                        params.set('idVeiculo', entidade.idVeiculo);
                                        params.set('hodometro', String(parseDecimal(entidade.hodometro) || 0));
                                        params.set('pecas', JSON.stringify(pecasParam));
                                        navigate.push(`/plano-manutencao?${params.toString()}`);
                                    }
                                },
                                {
                                    icon: <FaTimesCircle />,
                                    title: "Não, obrigado",
                                    description: "Continuar sem criar plano",
                                    onClick: () => { }
                                }
                            ]
                        });
                    }
                }
            }, 250);

        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
            setIsSubmiting(false);
        }
    }, [
        isSubmiting,
        token,
        modo,
        servicoVeiculoServico,
        servicoVeiculoPeca,
        servicoVeiculoServicosSelecionados,
        servicoVeiculoPecasSelecionados,
        ehOrdemServico,
        totalServicos,
        totalPecas,
        garantiaRemovida,
        reciboRemovido,
        imagemRemovida,
        veiculosOptions,
        prestadorDeServicoOptions,
        integradoRastreador,
        modoConversao,
        osParaConverter,
        osEmEdicao
    ]);

    const temPermissao = useMemo(() => usuarioTemPermissao(token, 'servicoveiculo_visualizar'), [token]);

    useEffect(() => {
        if (forcarAtualizacaoGrid == true) {
            setForcarAtualizacaoGrid(false);
        }
    }, [forcarAtualizacaoGrid]);

    // Pre-preenchimento vindo do Plano de Manutenção
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const idVeiculo = params.get('idVeiculo');
        const hodometro = params.get('hodometro');
        const idPeca = params.get('idPeca');

        if (idVeiculo) {
            setTimeout(() => {
                const updates: any = { idVeiculo };
                if (hodometro) updates.hodometro = Number(hodometro);
                setEntidadeParaAtualizarNoModal(updates);
                setForcarAtualizacaoDeEntidadeNoModal(true);
                setModo(TipoFormulario.tpCadastro);
                setServicoVeiculoSelecionado({} as ServicoVeiculo);
                setExibirFormModal(true);

                if (idPeca) {
                    api.get(`/Peca/${idPeca}`).then(res => {
                        const p = res.data;
                        if (p) {
                            setServicoVeiculoPecasSelecionados([{
                                id: p.id,
                                nome: p.nome,
                                marca: p.marca,
                                modelo: p.modelo,
                                tipoVeiculo: p.tipoVeiculo,
                                selected: false,
                                provenienteDoEstoque: 'nao',
                                qtdEstoque: 1,
                                valor: 0
                            }]);
                        }
                    }).catch(() => { });
                }

                // Limpar query params
                navigate.replace('/manutencoes');
            }, 500);
        }
    }, [location.search]);

    const tratarErro = useCallback((error: AxiosError<ApiError>) => {
        setCarregando(false);
        setIsSubmiting(false);
        const errorMessage = error.response?.data?.Mensagem || 'Erro desconhecido';
        toast.error(`Não foi possível continuar a operação Manutenção: ${errorMessage}`);
    }, []);

    useEffect(() => {
        api.get(`/bancoPorEmpresa/${obterIdTenent(token)}?apenasAtivos=true`)
            .then(r => setBancosManutencaoOpcoes(r.data.map((b: Banco) => ({ label: b.apelido, valor: b.id }))))
            .catch(() => setBancosManutencaoOpcoes([]));
    }, [token]);

    useEffect(() => {
        api.get('ConfiguracaoFilial/ResolvidaAtual')
            .then(r => setIntegradoRastreador(!!r.data?.azulMonitorConfigurado))
            .catch(() => setIntegradoRastreador(false));
    }, [token]);

    const handleFecharModal = useCallback(() => {
        setExibirFormModal(false);
        setEhOrdemServico(false);
        setModoConversao(false);
        setOsParaConverter(null);
        setOsEmEdicao(null);

        if ((modo === TipoFormulario.tpEdicao || modo === TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }, [modo, fezAlgumaAcao]);

    const handleFecharModalServico = useCallback(() => {
        setExibirFormModalServico(false);
        setRealizarConsultaServico(true);
    }, []);

    const handleFecharModalPeca = useCallback(() => {
        setExibirFormModalPeca(false);
        setRealizarConsultaPeca(true);
    }, []);

    const handleCadastrar = useCallback(() => {
        if (usuarioTemPermissao(token, 'servicoveiculo_novo')) {
            setGerandoOS(false);
            setEhOrdemServico(false);
            setModoConversao(false);
            setOsParaConverter(null);
            setOsEmEdicao(null);
            setEntidadeParaAtualizarNoModal({
                parcelas: 1,
                tipoManutencao: 'normal'
            });
            setForcarAtualizacaoDeEntidadeNoModal(true);
            setUsaPecaDoEstoque(false);
            setModo(TipoFormulario.tpCadastro);
            setServicoVeiculoSelecionado({} as ServicoVeiculo);

            setServicoVeiculoServicosSelecionados([]);
            setServicoVeiculoPecasSelecionados([]);
            setServicoVeiculoServico([]);
            setServicoVeiculoPeca([]);
            setTotalServicos(0);
            setTotalPecas(0);

            setTriggerGerarPDFOS(0);

            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar um novo serviço');
        }
    }, [token]);

    const handleEditar = useCallback(async (servicoVeiculo: any) => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_editar')) {
            toast.error('Você não tem permissão para editar um serviço')
            return;
        }

        setServicoVeiculoServicosSelecionados([]);
        setServicoVeiculoPecasSelecionados([]);
        popularGridDePecas(servicoVeiculo);
        popularGridDeServicos(servicoVeiculo);

        try {
            const response = await api.get(`/servicoveiculo/${servicoVeiculo.id}`);
            const servicoCompleto = { ...servicoVeiculo, ...response.data };
            setModo(TipoFormulario.tpEdicao);
            setServicoVeiculoSelecionado(servicoCompleto);
            setMostrarAvancadoManutencao(!!(servicoCompleto as ServicoVeiculo).idBanco);
            setExibirFormModal(true);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        }
    }, [token]);

    const handleExclusao = useCallback(async (servico: ServicoVeiculo) => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_excluir')) return;

        setCarregando(true);
        try {
            await api.delete(`/servicoveiculo/${servico.id}`);
            setTimeout(() => {
                toast.success('Manutenção foi excluída com sucesso')
                setRealizarConsulta(true);
                setCarregando(false);
            }, 250);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        }
    }, [token]);

    const popularGridDePecas = useCallback((servicoVeiculo: ServicoVeiculo) => {
        let usaEstoque = false;
        const novasPecas: any[] = [];
        const somaPecas = servicoVeiculo.servicoVeiculoPecas.reduce((acc, peca: any) => {
            if (peca.provenienteDoEstoque === 'sim') {
                usaEstoque = true;
            }
            const valorPecaCalculo = peca.provenienteDoEstoque === 'sim' ? 0 : (parseDecimal(peca.valor) || 0);
            const total = (parseDecimal(peca.quantidadeUsada) || 0) * valorPecaCalculo;

            novasPecas.push({
                id: peca.idPeca,
                nome: peca.peca.nome,
                marca: peca.peca.marca,
                modelo: peca.peca.modelo,
                tipoVeiculo: peca.peca.tipoVeiculo,
                selected: false,
                provenienteDoEstoque: peca.provenienteDoEstoque,
                qtdEstoque: peca.quantidadeUsada,
                valor: peca.valor
            });
            return acc + total;
        }, 0);
        setServicoVeiculoPecasSelecionados(novasPecas);
        setTotalPecas(somaPecas);
        setUsaPecaDoEstoque(usaEstoque);
    }, []);

    useEffect(() => {
        servicoVeiculoSelecionado.valorPecas = totalPecas;
        servicoVeiculoSelecionado.valorMaoDeObra = totalServicos;
    }, [totalPecas, totalServicos])

    const popularGridDeServicos = useCallback((servicoVeiculo: ServicoVeiculo) => {
        const novosServicos: any[] = [];
        const somaServicos = servicoVeiculo.servicoVeiculoServicos.reduce((acc, servico: any) => {
            novosServicos.push({
                id: servico.idServico,
                nome: servico.servico.nome,
                periodoEmKm: servico.servico.periodoEmKm,
                valor: servico.valor,
                selected: false
            });
            return acc + (parseDecimal(servico.valor) || 0);
        }, 0);
        setServicoVeiculoServicosSelecionados(novosServicos);
        setTotalServicos(somaServicos);
    }, []);

    const handleVisualizacao = useCallback((servicoVeiculo: any) => {
        setServicoVeiculoServicosSelecionados([]);
        setServicoVeiculoPecasSelecionados([]);
        popularGridDePecas(servicoVeiculo);
        popularGridDeServicos(servicoVeiculo);

        if (usuarioTemPermissao(token, 'servicoveiculo_visualizar')) {
            setServicoVeiculoSelecionado(servicoVeiculo);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao);
        }
    }, [token]);

    const requisicaoBemSucedida = useCallback(() => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success('Manutenção salva com sucesso');
        setFezAlgumaAcao(true);
    }, []);

    const requisicaoBemSucedidaServico = useCallback(() => {
        setExibirFormModalServico(false);
        setRealizarConsultaServico(true);
        toast.success('Serviço salvo com sucesso');
    }, []);

    const requisicaoBemSucedidaPeca = useCallback(() => {
        setRealizarConsultaPeca(true);
        setExibirFormModalPeca(false);
        toast.success('Peça salva com sucesso');
    }, []);

    const fetchData = useCallback(async (endpoint: string, setData: (data: any) => void, errorMessage: string, transform?: (data: any) => any) => {
        if (!temPermissao || !realizarConsulta) return;

        iniciarConsulta();
        try {
            const response = await api.get(`${endpoint}/${obterIdTenent(token)}`);
            setData(transform ? transform(response.data) : response.data);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            finalizarConsulta();
        }
    }, [temPermissao, realizarConsulta, token]);

    useEffect(() => {
        if (realizarConsulta) {
            fetchServicosVeiculos(paginationModel.page, paginationModel.pageSize);
            const consultas = [
                fetchData('/VeiculoPorEmpresaAtivos', setVeiculosOptions, 'Não foi possível realizar a consulta: ',
                    data => {
                        setVeiculosRaw(data);
                        return data.map((veiculo: any) => ({
                            valor: veiculo.id,
                            label: labelComFilial(`${veiculo.placa}: ${veiculo.marca} ${veiculo.modelo} ${veiculo.ano}`, veiculo.idFilial)
                        }));
                    }),

                fetchData('/PrestadorServicosPorEmpresa', setPrestadorDeServicoOptions, 'Não foi possível realizar a consulta: ',
                    data => data.map((servico: any) => ({
                        valor: servico.id,
                        label: servico.nome
                    }))),
            ];

            Promise.all(consultas).finally(() => {
                setRealizarConsulta(false);
            });
        }
    }, [realizarConsulta, fetchData]);

    const fetchServicosVeiculos = async (page: number, pageSize: number) => {
        if (!temPermissao) return;

        setCarregando(true);
        try {
            const pageToSend = page + 1;
            const idEmpresa = obterIdTenent(token);

            const params = new URLSearchParams();
            params.append('page', String(pageToSend));
            params.append('pageSize', String(pageSize));
            params.append('idEmpresa', idEmpresa);

            if (idVeiculoEscolhido) {
                params.append('idVeiculo', idVeiculoEscolhido);
            }

            if (pecasEscolhidas && pecasEscolhidas.length > 0) {
                const pecasValidas = pecasEscolhidas.filter(p => p && p.trim() !== "");
                if (pecasValidas.length > 0) {
                    params.append('pecasEscolhidas', pecasValidas.join(','));
                }
            }

            if (servicosEscolhidos && servicosEscolhidos.length > 0) {
                const servicosValidos = servicosEscolhidos.filter(s => s && s.trim() !== "");
                if (servicosValidos.length > 0) {
                    params.append('servicosEscolhidos', servicosValidos.join(','));
                }
            }

            if (dataInicio) params.append('dataInicial', dataInicio.toISOString());
            if (dataFim) params.append('dataFinal', dataFim.toISOString());
            if (tipoPeriodo === "pagamento") params.append('tipoPeriodo', 'pagamento');

            const response = await api.get(`servicoVeiculo/filtrar?${params.toString()}`);

            const items = response.data.items || (Array.isArray(response.data) ? response.data : []);
            const total = response.data.totalCount || items.length;

            setServicosVeiculos(items);
            setRowCount(total);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };

    useEffect(() => {
        if (!realizarConsulta) {
            fetchServicosVeiculos(paginationModel.page, paginationModel.pageSize);
        }
    }, [paginationModel]);

    useEffect(() => {
        if (!temPermissao || !realizarConsultaPeca) return;

        const fetchPecas = async () => {
            iniciarConsulta();
            try {
                const [pecasResponse, estoqueResponse] = await Promise.all([
                    api.get(`/PecaPorEmpresa/${obterIdTenent(token)}`),
                    api.get(`/EstoquePorEmpresa/${obterIdTenent(token)}`)
                ]);

                const pecasBase = pecasResponse.data.map((peca: any) => ({
                    ...peca,
                    provenienteDoEstoque: 'não'
                }));
                // Manutencao so usa pecas com estoque > 0 (zerados aparecem na listagem de Estoque, mas nao aqui)
                const pecasEstoque = estoqueResponse.data
                    .filter((estoque: any) => Number(estoque.quantidade) > 0)
                    .map((estoque: any) => ({
                        id: estoque.idPeca,
                        nome: estoque.peca.nome,
                        marca: estoque.peca.marca,
                        modelo: estoque.peca.modelo,
                        valor: estoque.valor,
                        qtdEstoque: estoque.quantidade,
                        idEmpresa: obterIdTenent(token),
                        tipoVeiculo: estoque.peca.tipoVeiculo,
                        vidaUtilEmKm: estoque.peca.vidaUtilEmKm,
                        provenienteDoEstoque: 'sim'
                    }));
                setPecas([...pecasEstoque, ...pecasBase]);
                setRealizarConsultaPeca(false);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>)
            } finally {
                finalizarConsulta();
            }
        };
        fetchPecas();
    }, [temPermissao, realizarConsultaPeca, token]);

    useEffect(() => {
        if (!temPermissao || !realizarConsultaServico) return;

        const fetchServicos = async () => {
            try {
                const response = await api.get(`/servicoPorEmpresa/${obterIdTenent(token)}`);
                setTimeout(() => {
                    setServicos(response.data);
                    setRealizarConsultaServico(false);
                }, 250);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            }
        };
        fetchServicos();
    }, [temPermissao, realizarConsultaServico, token]);

    useEffect(() => {
        if (!temPermissao || !realizarConsultaOS) return;

        const fetchOrdensDeServico = async () => {
            setCarregandoOS(true);
            try {
                const response = await api.get(`/OrdemDeServicoPorEmpresa/${obterIdTenent(token)}`);
                setOrdensDeServico(response.data || []);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            } finally {
                setCarregandoOS(false);
                setRealizarConsultaOS(false);
            }
        };
        fetchOrdensDeServico();
    }, [temPermissao, realizarConsultaOS, token]);

    const carregarGridsDaOS = useCallback((os: OrdemDeServico) => {
        const novosServicos: any[] = (os.ordemDeServicoServicos || []).map((s: any) => ({
            id: s.idServico,
            nome: s.servico?.nome,
            periodoEmKm: s.servico?.periodoEmKm,
            valor: s.valor ?? 0,
            selected: false
        }));

        const novasPecas: any[] = (os.ordemDeServicoPecas || []).map((p: any) => ({
            id: p.idPeca,
            nome: p.peca?.nome,
            marca: p.peca?.marca,
            modelo: p.peca?.modelo,
            tipoVeiculo: p.peca?.tipoVeiculo,
            selected: false,
            provenienteDoEstoque: p.provenienteDoEstoque || 'nao',
            qtdEstoque: p.quantidadeUsada,
            valor: p.valor ?? 0
        }));

        let somaServicos = 0;
        novosServicos.forEach((s: any) => { somaServicos += parseDecimal(s.valor) || 0; });

        let somaPecas = 0;
        let usaEstoque = false;
        novasPecas.forEach((p: any) => {
            if (p.provenienteDoEstoque === 'sim') usaEstoque = true;
            const valor = p.provenienteDoEstoque === 'sim' ? 0 : (parseDecimal(p.valor) || 0);
            somaPecas += valor * (parseDecimal(p.qtdEstoque) || 0);
        });

        setServicoVeiculoServicosSelecionados(novosServicos);
        setServicoVeiculoPecasSelecionados(novasPecas);
        setServicoVeiculoServico(novosServicos);
        setServicoVeiculoPeca(novasPecas);
        setTotalServicos(somaServicos);
        setTotalPecas(somaPecas);
        setUsaPecaDoEstoque(usaEstoque);

        return { somaServicos, somaPecas };
    }, []);

    const handleConverterOS = useCallback((os: OrdemDeServico) => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_novo')) {
            toast.error('Você não tem permissão para converter uma Ordem de Serviço');
            return;
        }

        const { somaServicos, somaPecas } = carregarGridsDaOS(os);

        setEhOrdemServico(false);
        setModoConversao(true);
        setOsParaConverter(os);
        setOsEmEdicao(null);
        setModo(TipoFormulario.tpCadastro);
        setServicoVeiculoSelecionado({} as ServicoVeiculo);
        setMostrarAvancadoManutencao(false);

        setEntidadeParaAtualizarNoModal({
            idVeiculo: os.idVeiculo,
            hodometro: os.hodometro,
            idPrestadorServico: os.idPrestadorServico,
            descricao: os.descricao || '',
            dataRealizado: os.dataRealizado,
            valorMaoDeObra: somaServicos,
            valorPecas: somaPecas,
            valor: somaServicos + somaPecas,
            parcelas: 1,
            ...(os.idFilial ? { idFilial: os.idFilial } : {})
        });
        setForcarAtualizacaoDeEntidadeNoModal(true);
        setExibirFormModal(true);
    }, [token, carregarGridsDaOS]);

    const handleEditarOS = useCallback((os: OrdemDeServico) => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_editar')) {
            toast.error('Você não tem permissão para editar uma Ordem de Serviço');
            return;
        }

        carregarGridsDaOS(os);

        setEhOrdemServico(true);
        setModoConversao(false);
        setOsParaConverter(null);
        setOsEmEdicao(os);
        setModo(TipoFormulario.tpEdicao);
        setServicoVeiculoSelecionado({} as ServicoVeiculo);
        setMostrarAvancadoManutencao(false);

        setEntidadeParaAtualizarNoModal({
            idVeiculo: os.idVeiculo,
            hodometro: os.hodometro,
            idPrestadorServico: os.idPrestadorServico,
            descricao: os.descricao || '',
            dataRealizado: os.dataRealizado,
            ...(os.idFilial ? { idFilial: os.idFilial } : {})
        });
        setForcarAtualizacaoDeEntidadeNoModal(true);
        setExibirFormModal(true);
    }, [token, carregarGridsDaOS]);

    const handleCancelarOS = useCallback(async (os: OrdemDeServico) => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_editar')) {
            toast.error('Você não tem permissão para cancelar uma Ordem de Serviço');
            return;
        }
        if (!await confirm('Deseja realmente cancelar esta Ordem de Serviço?')) return;

        setCarregandoOS(true);
        try {
            await api.put(`/ordemDeServico/${os.id}/cancelar`);
            setTimeout(() => {
                toast.success('Ordem de Serviço cancelada com sucesso');
                setRealizarConsultaOS(true);
            }, 250);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
            setCarregandoOS(false);
        }
    }, [token]);

    const handleExcluirOS = useCallback(async (os: OrdemDeServico) => {
        if (!usuarioTemPermissao(token, 'servicoveiculo_excluir')) {
            toast.error('Você não tem permissão para excluir uma Ordem de Serviço');
            return;
        }

        if (!await confirm('Deseja realmente excluir esta Ordem de Serviço?')) return;

        setCarregandoOS(true);
        try {
            await api.delete(`/ordemDeServico/${os.id}`);
            setTimeout(() => {
                toast.success('Ordem de Serviço excluída com sucesso');
                setRealizarConsultaOS(true);
            }, 250);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
            setCarregandoOS(false);
        }
    }, [token]);

    const handlePdfOS = useCallback(async (os: OrdemDeServico) => {
        let veiculoInfo: VeiculoInfo | undefined;
        try {
            const responseVeiculo = await api.get(`Veiculo/${os.idVeiculo}`);
            const veiculo = responseVeiculo.data;
            veiculoInfo = {
                placa: veiculo.placa || 'N/A',
                marca: veiculo.marca || 'N/A',
                modelo: veiculo.modelo || 'N/A',
                ano: veiculo.ano ? String(veiculo.ano) : 'N/A'
            };
        } catch (error) {
            veiculoInfo = { placa: 'N/A', marca: 'N/A', modelo: 'N/A', ano: 'N/A' };
        }

        const manutencaoOS: any = {
            id: os.id,
            hodometro: os.hodometro,
            descricao: os.descricao || '',
            dataRealizado: os.dataRealizado,
            veiculo: veiculoInfo,
            prestadorServico: (os as any).prestadorServico ? { nome: (os as any).prestadorServico.nome } : undefined,
            servicoVeiculoServicos: (os.ordemDeServicoServicos || []).map((s: any) => ({ servico: { nome: s.servico?.nome }, nome: s.servico?.nome })),
            servicoVeiculoPecas: (os.ordemDeServicoPecas || []).map((p: any) => ({ peca: { nome: p.peca?.nome, marca: p.peca?.marca, modelo: p.peca?.modelo }, nome: p.peca?.nome, marca: p.peca?.marca, modelo: p.peca?.modelo, quantidadeUsada: p.quantidadeUsada })),
            imagem: undefined,
        };

        setServicoVeiculoSelecionado(manutencaoOS);
        setTriggerGerarPDFOS(prev => prev + 1);
    }, []);

    const colunasOS = useMemo(() => [
        {
            field: 'veiculo',
            headerName: 'Veículo',
            flex: 1.5,
            renderCell: (params: any) => {
                const veiculo = params.row.veiculo;
                if (!veiculo) return '';
                return (
                    <Box display="flex" alignItems="center" gap={1.25}>
                        <Box color="#4A5568" display="flex"><FaCarSide size={16} /></Box>
                        <Box display="flex" flexDirection="column">
                            <Typography variant="body2" fontWeight={600} lineHeight={1.3}>{veiculo.placa}</Typography>
                            <Typography variant="caption" color="#718096" lineHeight={1.3}>{[veiculo.marca, veiculo.modelo].filter(Boolean).join(' ')}</Typography>
                        </Box>
                    </Box>
                );
            },
            valueGetter: (params: any) => params.row.veiculo ? `${params.row.veiculo.placa} - ${params.row.veiculo.marca} - ${params.row.veiculo.modelo}` : ''
        },
        { field: 'prestadorServico', headerName: 'Prestador', flex: 1, valueGetter: (params: any) => params.row.prestadorServico?.nome || '' },
        { field: 'hodometro', headerName: 'Hodômetro', flex: 0.6 },
        {
            field: 'dataRealizado',
            headerName: 'Previsão',
            flex: 1,
            valueGetter: (params: any) => params.value ? new Date(params.value) : null,
            renderCell: (params: any) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                return isNaN(date.getTime()) ? '' : date.toLocaleDateString("pt-BR");
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.8,
            renderCell: (params: any) => {
                const status = Number(params.value);
                let backgroundColor = '#9CA3AF';
                let texto = 'Nenhum';
                if (status === StatusOrdemDeServico.Aberta) { backgroundColor = '#FFC107'; texto = 'Aberta'; }
                else if (status === StatusOrdemDeServico.Convertida) { backgroundColor = '#4CAF50'; texto = 'Convertida'; }
                else if (status === StatusOrdemDeServico.Cancelada) { backgroundColor = '#f44336'; texto = 'Cancelada'; }
                return (
                    <span style={{ backgroundColor, color: 'white', padding: '4px 10px', borderRadius: '5px', fontWeight: 'bold', fontSize: '12px' }}>
                        {texto}
                    </span>
                );
            }
        },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ], [empresaTemFiliais, filiaisOptions]);

    const buscarUltimoHodometroLocal = useCallback((idVeiculo: string) => {
        if (!servicosVeiculos || servicosVeiculos.length === 0) return 0;

        const manutencoesDoVeiculo = servicosVeiculos.filter(
            (sv: ServicoVeiculo) => sv.idVeiculo === idVeiculo
        );

        if (manutencoesDoVeiculo.length === 0) return 0;

        const ordenadas = [...manutencoesDoVeiculo].sort((a, b) => {
            const dateA = new Date(a.dataRealizado).getTime();
            const dateB = new Date(b.dataRealizado).getTime();

            if (dateB !== dateA) return dateB - dateA;

            return b.hodometro - a.hodometro;
        });

        return ordenadas[0].hodometro || 0;
    }, [servicosVeiculos]);

    const opcoesFormatadas = veiculosOptions.map(op => ({
        label: op.label,
        value: String(op.valor)
    }));

    const pecasFormatadas = pecas.map(p => ({
        label: `${p.marca} ${p.modelo} ${p.nome}`,
        value: String(p.id)
    }));

    const servicosFormatados = servicos.map(s => ({
        label: `${s.nome}`,
        value: String(s.id)
    }));

    const handleBuscar = () => {
        setPaginationModel(prev => ({ ...prev, page: 0 }));
        fetchServicosVeiculos(0, paginationModel.pageSize);
    }

    const configFiltros: ConfiguracaoFiltros = {
        carregando: carregando,
        aoBuscar: handleBuscar,
        tipoPeriodo: tipoPeriodo,
        onChangeTipoPeriodo: setTipoPeriodo,
        datas: {
            labelInicio: "De",
            labelFim: "Até",
            dataInicio: dataInicio,
            dataFim: dataFim,
            onChangeDataInicio: setDataInicio,
            onChangeDataFim: setDataFim
        },
        dropdowns: [
            {
                key: 'tipo',
                label: 'Veículo',
                placeholder: 'Selecione um veículo',
                multiSelect: false,
                opcoes: opcoesFormatadas,
                value: idVeiculoEscolhido,
                onChange: (val) => setIdVeiculoEscolhido(val)
            },
            {
                key: 'pecas',
                label: 'Peças',
                placeholder: 'Selecione a(s) peça(s)',
                multiSelect: true,
                opcoes: pecasFormatadas,
                value: pecasEscolhidas,
                onChange: (val) => setPecasEscolhidas(val)
            },
            {
                key: 'servicos',
                label: 'Serviços',
                placeholder: 'Selecione o(s) serviço(s)',
                multiSelect: true,
                opcoes: servicosFormatados,
                value: servicosEscolhidos,
                onChange: (val) => setServicosEscolhidos(val)
            }
        ]
    };

    return (
        <LocaSmartLayout>
            <Tabs
                value={abaManutencao}
                onChange={(_, v) => setAbaManutencao(v)}
                sx={{ mb: 1, minHeight: 36, '& .MuiTab-root': { minHeight: 36, py: 0.5, textTransform: 'none', fontWeight: 600 } }}
            >
                <Tab label="Manutenções" />
                <Tab label="Ordens de Serviço" />
            </Tabs>

            {abaManutencao === 0 && (
            <Listagem
                permissoes={crudDe('servicoveiculo')}
                colunas={colunas}
                exportOptions={exportOptions}
                nomePropriedade="descricao"
                carregando={carregando}
                IconeEntidade={FaTools}
                exibirAcoesDeCrud={true}
                acoesExtras={[
                    {
                        Icone: FaMoneyBillAlt,
                        OnClick: (entidade) => {
                            if (entidade.id) {
                                navigate.push(`/lancamento?manutencao=${entidade.id}`)
                            }
                        },
                        Texto: 'Ir para o lançamento financeiro',
                        Cor: '#047857',
                        Tamanho: "medium"
                    },
                ]}
                linhas={servicosVeiculos}
                handleEditar={handleEditar}
                handleCriar={handleCadastrar}
                handleExclusao={handleExclusao}
                nomeEntidade="Manutenções"
                handleVisualizacao={handleVisualizacao}
                handleSelecionarEntidade={setServicoVeiculoSelecionado}
                rowCount={rowCount}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                paginationMode="server"
                filtros={configFiltros}
                acoesEmLote={[
                    ...(getAcaoEmLoteFilial('ServicoVeiculo', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('ServicoVeiculo', () => setRealizarConsulta(true))!] : []),
                ]}
            />
            )}

            {abaManutencao === 1 && (
            <Listagem
                permissoes={crudDe('servicoveiculo')}
                colunas={colunasOS}
                nomePropriedade="descricao"
                carregando={carregandoOS}
                IconeEntidade={FaTools}
                exibirAcoesDeCrud={false}
                nomeEntidade="Ordens de Serviço"
                linhas={ordensDeServico}
                handleCriar={() => {
                    if (usuarioTemPermissao(token, 'servicoveiculo_novo')) {
                        setGerandoOS(false);
                        setModoConversao(false);
                        setOsParaConverter(null);
                        setOsEmEdicao(null);
                        setEhOrdemServico(true);
                        setModo(TipoFormulario.tpCadastro);
                        setServicoVeiculoSelecionado({} as ServicoVeiculo);
                        setServicoVeiculoServicosSelecionados([]);
                        setServicoVeiculoPecasSelecionados([]);
                        setServicoVeiculoServico([]);
                        setServicoVeiculoPeca([]);
                        setTotalServicos(0);
                        setTotalPecas(0);
                        setUsaPecaDoEstoque(false);
                        setEntidadeParaAtualizarNoModal({ tipoManutencao: 'os' });
                        setForcarAtualizacaoDeEntidadeNoModal(true);
                        setExibirFormModal(true);
                    } else {
                        toast.error('Você não tem permissão para cadastrar uma Ordem de Serviço');
                    }
                }}
                handleSelecionarEntidade={() => {}}
                acoesExtras={[
                    {
                        Icone: FaExchangeAlt,
                        OnClick: (entidade) => handleConverterOS(entidade),
                        Texto: 'Converter em manutenção',
                        Cor: '#047857',
                        Tamanho: 'medium',
                        Condicao: (entidade: any) => Number(entidade.status) === StatusOrdemDeServico.Aberta,
                        TooltipDisabled: 'Somente ordens abertas podem ser convertidas',
                    },
                    {
                        Icone: FaEdit,
                        OnClick: (entidade) => handleEditarOS(entidade),
                        Texto: 'Editar',
                        Tamanho: 'medium',
                        Condicao: (entidade: any) => Number(entidade.status) === StatusOrdemDeServico.Aberta,
                        TooltipDisabled: 'Somente ordens abertas podem ser editadas',
                    },
                    {
                        Icone: FaFilePdf,
                        OnClick: (entidade) => handlePdfOS(entidade),
                        Texto: 'Gerar PDF',
                        Cor: '#1F467E',
                        Tamanho: 'medium',
                    },
                    {
                        Icone: FaBan,
                        OnClick: (entidade) => handleCancelarOS(entidade),
                        Texto: 'Cancelar',
                        Cor: '#B45309',
                        Tamanho: 'medium',
                        Condicao: (entidade: any) => Number(entidade.status) === StatusOrdemDeServico.Aberta,
                        TooltipDisabled: 'Somente ordens abertas podem ser canceladas',
                    },
                    {
                        Icone: FaTrash,
                        OnClick: (entidade) => handleExcluirOS(entidade),
                        Texto: 'Excluir',
                        Cor: '#f44336',
                        Tamanho: 'medium',
                        Condicao: (entidade: any) => Number(entidade.status) === StatusOrdemDeServico.Aberta,
                        TooltipDisabled: 'Somente ordens abertas podem ser excluídas',
                    },
                ]}
            />
            )}

            <ModalForm
                urlTutorial="https://youtu.be/CIYUJC5AmMY"
                modo={modo}
                tamanho="lg"
                pages={pages}
                campos={campos}
                onSave={onSave}
                show={exibirFormModal}
                carregando={carregando}
                onHide={handleFecharModal}
                isSaving={isSubmiting}
                tituloBotaoOk={modoConversao ? 'Converter' : ehOrdemServico ? (modo === TipoFormulario.tpEdicao ? 'Salvar OS' : 'Gerar OS') : 'Salvar'}
                planoPremium={(!ehPlanoGratuito(token) && !estaEmPeriodoDeTeste(token))}
                onShow={() => {
                    if (modo === TipoFormulario.tpCadastro && !modoConversao) {
                        setServicoVeiculoServicosSelecionados([]);
                        setServicoVeiculoPecasSelecionados([]);
                        setServicoVeiculoPeca([]);
                        setServicoVeiculoServico([]);
                        setTotalManutencao(0);
                        setTotalPecas(0);
                        setTotalServicos(0);
                        setForcarAtualizacaoGrid(true);
                    }
                }}
                onCancel={handleFecharModal}
                ajudinha={{ texto: "Aqui você poderá cadastrar serviços que serão utilizados em movimentações, como a de Manutenções. Esses cadastros facilitam a seleção nas telas de movimentação, garantindo uma escolha rápida e a padronização das operações.", autoCloseTime: 3, ehDestacado: true }}
                entidadeSelecionada={servicoVeiculoSelecionado}
                apiConfig={{ endpoint: 'servicoveiculo', idTenentCampo: 'idEmpresa', requisicaoBemSucedida, tratarErro }}
                atualizacaoEntidade={{ entidadeUsadaParaAtualizacao: entidadeParaAtualizarNoModal, forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModal }}
                onFileRemoved={(campo: string) => {
                    if (campo == 'recibo') {
                        setReciboRemovido(true);
                    } else if (campo == 'garantia') {
                        setGarantiaRemovida(true);
                    }
                }}
                onImageRemoved={(campo: string) => {
                    if (campo == 'imagem') {
                        setImagemRemovida(true);
                    }
                }}
            />

            <ModalForm
                modo={modo}
                tamanho="lg"
                campos={camposServico}
                carregando={carregando}
                show={exibirFormModalServico}
                onHide={handleFecharModalServico}
                onCancel={handleFecharModalServico}
                isSaving={isSubmiting}
                titulo="Criar Serviço"
                apiConfig={{ endpoint: 'servico', idTenentCampo: 'idEmpresa', requisicaoBemSucedida: requisicaoBemSucedidaServico, tratarErro }}
            />

            <ModalForm
                modo={modo}
                tamanho="lg"
                campos={camposPecas}
                show={exibirFormModalPeca}
                carregando={carregando}
                onHide={handleFecharModalPeca}
                onCancel={handleFecharModalPeca}
                titulo="Criar Peça"
                apiConfig={{ endpoint: 'peca', idTenentCampo: 'idEmpresa', requisicaoBemSucedida: requisicaoBemSucedidaPeca, tratarErro }}
            />

            <ReciboManutencao
                manutencao={servicoVeiculoSelecionado as any}
                trigger={triggerGerarPDFOS}
            />
        </LocaSmartLayout>
    );
}

export default ServicoVeiculoListagem;